var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgSpin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1008_24207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.984 89.474C190.575 98.5801 174.224 106.067 172.253 114.465C170.185 123.167 181.119 137.635 176.588 145.021C172.056 152.508 154.523 148.765 147.923 154.431C141.421 160.097 142.012 178.41 133.935 181.85C126.153 185.088 114.234 171.53 105.369 172.137C96.5031 172.744 86.5541 187.921 78.3781 185.796C69.9067 183.671 68.0351 165.358 60.7457 160.704C53.4564 156.05 36.612 162.222 31.0957 155.443C25.5794 148.765 34.4449 132.88 31.1942 124.482C27.845 116.59 10.6067 111.531 10.0156 102.526C9.4246 93.4199 25.7764 85.9327 27.7465 77.5349C29.8151 68.8335 18.8811 54.3649 23.4123 46.9789C27.9436 39.4916 45.4775 43.2352 52.0773 37.5692C58.5786 31.9032 57.9876 13.5898 66.065 10.1498C73.8469 6.91204 85.766 20.47 94.6315 19.8629C103.497 19.2559 113.446 4.07903 121.622 6.20379C130.093 8.32854 131.965 26.6419 139.254 31.2961C146.544 35.9504 163.388 29.7785 168.904 36.5574C174.421 43.2352 165.555 59.1203 168.806 67.5182C172.155 75.4101 189.295 80.469 189.984 89.474Z",
    fill: "url(#paint0_linear_1008_24207)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.554 171.226C83.3737 173.724 79.1254 172.617 77.377 168.971C77.3154 168.842 77.255 168.717 77.196 168.596C74.5364 162.727 71.5813 155.948 65.7695 152.205C61.0412 149.169 55.3279 148.765 50.4027 148.765C49.0236 148.765 47.6445 148.765 46.2655 148.866C45.0834 148.866 43.8028 148.967 42.6208 148.967V148.967C40.4472 148.967 38.8878 147.089 39.2475 144.946C39.4643 143.654 39.7241 142.349 39.9611 141.278C41.2417 134.802 42.6208 127.517 40.0596 120.941C37.4985 114.465 31.6867 110.418 26.4659 106.776V106.776C22.702 104.13 22.3703 99.3493 25.6779 96.1518V96.1518C30.3076 91.8011 35.5284 86.8433 37.203 80.1655C38.8776 73.2854 36.5135 66.2028 34.3463 60.0309V60.0309C32.9884 56.0459 35.3978 52.2171 39.5671 51.6331V51.6331C45.8714 50.9248 53.0623 50.0142 58.3816 45.4612C63.6024 40.9081 65.671 33.8256 67.444 27.6537C67.4847 27.5074 67.5273 27.3554 67.5715 27.1985C68.6774 23.2789 72.7268 21.7709 76.3095 23.7077V23.7077C81.5303 26.7431 87.5391 30.1832 94.0404 30.1832C94.4344 30.1832 94.927 30.1832 95.321 30.1832C102.315 29.6773 108.225 25.1242 113.347 21.0771V21.0771C116.551 18.5607 120.764 19.6616 122.525 23.3349C122.587 23.4628 122.647 23.5872 122.705 23.7077C125.365 29.5761 128.32 36.3551 134.132 40.0987C138.86 43.1341 144.574 43.5388 149.499 43.5388C150.878 43.5388 152.257 43.5388 153.636 43.4376C154.818 43.4376 156.099 43.3364 157.281 43.3364V43.3364C159.454 43.3364 161.014 45.2141 160.654 47.3577C160.437 48.6494 160.177 49.9549 159.94 51.026C158.66 57.5015 157.281 64.7863 159.842 71.363C162.403 77.8384 168.215 81.8856 173.435 85.528V85.528C177.199 88.1732 177.531 92.9542 174.224 96.1518V96.1518C169.594 100.502 164.373 105.46 162.698 112.138C161.024 119.018 163.388 126.101 165.555 132.273V132.273C166.913 136.258 164.504 140.086 160.334 140.67V140.67C154.03 141.379 146.839 142.289 141.52 146.842C136.299 151.395 134.23 158.478 132.457 164.65C132.417 164.796 132.374 164.948 132.33 165.105C131.224 169.025 127.175 170.533 123.592 168.596V168.596C118.371 165.56 112.362 162.12 105.861 162.12C105.467 162.12 104.974 162.12 104.58 162.12C97.5866 162.626 91.6763 167.179 86.554 171.226V171.226Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1008_24207",
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1008_24207"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1008_24207",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1008_24207",
    x1: 100,
    y1: 186,
    x2: 100,
    y2: -16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.377727,
    stopColor: "#FFF23F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#FFF23F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgSpin);
export default __webpack_public_path__ + "static/media/bg-spin.181a0bb8195d9a5497f88eedab394a90.svg";
export { ForwardRef as ReactComponent };